export const JourneyApiColumns = {
    DOMAIN_ID: 'domain.id',
    DOMAIN_NAME: 'domain.name',

    // Preferred keys — use these in new code
    'JOURNEY.ID': 'campaign.id',
    'JOURNEY.NAME': 'campaign.name',
    'JOURNEY.STATUS': 'campaign.status',
    'JOURNEY.DATE_START': 'campaign.date_start',
    'JOURNEY.DATE_END': 'campaign.date_end',

    /** @deprecated Use JOURNEY.ID — kept for saved report compatibility */
    'CAMPAIGN.ID': 'campaign.id',
    /** @deprecated Use JOURNEY.NAME — kept for saved report compatibility */
    'CAMPAIGN.NAME': 'campaign.name',
    /** @deprecated Use JOURNEY.STATUS — kept for saved report compatibility */
    'CAMPAIGN.STATUS': 'campaign.status',
    /** @deprecated Use JOURNEY.DATE_START — kept for saved report compatibility */
    'CAMPAIGN.DATE_START': 'campaign.date_start',
    /** @deprecated Use JOURNEY.DATE_END — kept for saved report compatibility */
    'CAMPAIGN.DATE_END': 'campaign.date_end',

    'VARIANT.NAME': 'variant.name',
    'VARIANT.PERCENTAGE': 'variant.percentage',
    'STEP.NAME': 'step.name',
    'STEP.TYPE': 'step.type',

    ENTRANCES: 'entrances',
    EXITS: 'exits',
    DELIVERIES: 'deliveries',
    DELIVERY_RATE: 'delivery_rate_decimal',
    IMPRESSIONS: 'impressions',
    CLICKS: 'clicks',
    CTR: 'ctr_decimal',
    CPS: 'clicks_per_send',
    PURCHASES: 'purchases',
    PURCHASE_AMOUNT: 'purchase_amount',
}
